import { ApolloProvider } from "@apollo/client";

import { useGetApolloClient } from "../useGetApolloClient";

export const RegionalApolloProvider: React.FC<React.PropsWithChildren<any>> = ({
  children,
}) => {
  const client = useGetApolloClient();

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
